import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Procedimiento } from "src/app/model/procedimiento";

 
@Injectable({
  providedIn: 'root'
})
export class ProcedimientosService {

  API_URL:string = environment.API_URL; 

  constructor(
    private http: HttpClient,
   ) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  getProcedimiento(id: number): Observable<Procedimiento> {
    const url = `${this.API_URL}/procedimiento/get/${id}`;
    return this.http.get<Procedimiento>(url)
    .pipe(retry(1), catchError(this.handleError));
    
  }
  getProcedimientoByIdTramite(id: number): Observable<Procedimiento> {
    const url = `${this.API_URL}/procedimiento/get/tramite/${id}`;
    return this.http.get<Procedimiento>(url)
    .pipe(retry(1), catchError(this.handleError));
    
  }
  getProcedimientoCustom(id: number): Observable<Procedimiento> {
    const url = `${this.API_URL}/procedimiento/getCustom/${id}`;
    return this.http.get<Procedimiento>(url)
    .pipe(retry(1), catchError(this.handleError));
    
  }
  getProcedimientoCustomFormat(id: number): Observable<Procedimiento> {
    const url = `${this.API_URL}/procedimiento/getCustomFormat/${id}`;
    return this.http.get<Procedimiento>(url)
    .pipe(retry(1), catchError(this.handleError));
    
  }  
  getProcedimientos(): Observable<any> {
    return this.http
      .get<any>(`${this.API_URL}/procedimiento/list`);
  }

  updateVisibilityProc(id): Observable<any> {
    return this.http.get(`${this.API_URL}/procedimiento/visible/${id}`,{});
  }

  updateAperturaProc(id, form:FormData): Observable<any>{
    return this.http.post(`${this.API_URL}/procedimiento/fechaApertura/${id}`,form);
  }

  updateCierreProc(id, form:FormData): Observable<any>{
    return this.http.post(`${this.API_URL}/procedimiento/fechaCierre/${id}`,form);
  }

  updateProcedimiento(id,form:FormData):Observable<any>{
    return this.http.post(`${this.API_URL}/procedimiento/editar/${id}`,form);
  }

  borrarProcedimiento(id):Observable<any>{
    return this.http.delete(`${this.API_URL}/procedimiento/borrar/${id}`);
  }

  getProcedVisibles(): Observable<any> {
    return this.http.get(`${this.API_URL}/procedimiento/visible/list`,{});
  }

    // Error handling
    handleError(error: any) {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
      } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      //window.alert(errorMessage);
      return throwError(() => {
        return errorMessage;
      });
    }
   
}
